<template>
  <div class="giftPartScheme-bd tb" v-if="funcView.gift_part_scheme">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.gift_part_scheme_add">
          <el-button type="primary" @click="addPartScheme()">
            <i class="icon icon-add"></i>
            {{ $t('Common.com_add') }}
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 产品型号 -->
        <el-form-item style="float: right">
          <custom-select
            :filterable="true"
            v-model="formSearch.productCode"
            url="productCodeSelectList"
            :props="{ label: 'productName', value: 'productCode' }"
            :placeholder="$t('crm_giftPartScheme.qxzcpxh')"
            width="160px"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" index tableCode="giftPartScheme" @filter="filterChange" @sort="sortChange" @column="setColumn" height="100%" :slots="['triggerMethod', 'goodsList', 'action']">
        <template v-slot:goodsList="scope">
          <el-popover placement="bottom" width="800" @show="getRuleGoodsList(scope.row)" trigger="click">
            <el-table :data="scope.row.goodsList">
              <el-table-column type="index" label="#"></el-table-column>
              <el-table-column min-width="160" property="goodsName" :label="$t('crm_giftPartScheme.ling_jian_ming_cheng')">
                <template slot-scope="scope">{{ scope.row.erpCode || '' }}{{ scope.row.erpCode && scope.row.goodsName ? '/' : '' }}{{ scope.row.goodsName }}</template>
              </el-table-column>
              <el-table-column min-width="80" property="bookingNum" :label="$t('crm_giftPartScheme.ling_jian_shu_liang')"></el-table-column>
              <el-table-column min-width="80" property="isReplace" :label="$t('crm_giftPartScheme.yun_xu_geng_huan')">
                <template slot-scope="scope">
                  {{ scope.row.isReplace ? $t('Common.com_yes') : $t('Common.com_no') }}
                </template>
              </el-table-column>
              <el-table-column min-width="160" :label="$t('crm_giftPartScheme.geng_huan_ling_jian')">
                <template slot-scope="scope">
                  <span v-if="scope.row.childList">
                    {{ scope.row.childList.map((t) => `${t.erpCode || ''}${t.erpCode && t.goodsName? '/': ''}${t.goodsName}`).join('、') }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-button slot="reference" type="text">{{ $t('crm_giftPartScheme.cha_kan_xiang_qing') }}</el-button>
          </el-popover>
        </template>
        <template v-slot:triggerMethod="scope">
          {{ scope.row.triggerMethod == 1 ? $t('crm_giftPartScheme.yi_ci') : $t('crm_giftPartScheme.duo_ci') }}
        </template>
        <template v-slot:action="scope">
          <span></span>
          <el-button type="text" size="mini" @click="editPartScheme(scope.row)" v-if="funcView.gift_part_scheme_edit">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" @click="delPartScheme(scope.row)" v-if="funcView.gift_part_scheme_del">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <gift-part-scheme-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></gift-part-scheme-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import giftPartSchemeDialog from './children/gift_part_scheme_dialog.vue';

export default {
  name: 'gift_part_scheme',
  components: { giftPartSchemeDialog },
  data() {
    return {
      tableList: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        productCode: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: null,
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
    };
  },
  mounted: function () {
    this.getTableList();
    this.getFuncView();

  },
  methods: {
    // 获取赠送配件
    getRuleGoodsList(row) {
      this.$getJSON(`${apis.giveawayRuleInfoGoods}/${row.giveawayRuleId}`).then((res) => {
        const list = res.data;
        this.$set(row, 'goodsList', list);
      });
    },
    // 新增
    addPartScheme: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('crm_giftPartScheme.xin_zeng_fang_an');
      this.dialogVisible = true;
    },
    // 编辑
    editPartScheme: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('crm_giftPartScheme.bian_ji_fang_an');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 删除
    delPartScheme: function (row) {
      this.$showConfirm(this.$t('crm_giftPartScheme.qdyscxzzspjfam'))
        .then(() => {
          this.$postJSON(`${apis.giveawayRuleDel}/${row.giveawayRuleId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    getTableList() {
      this.$getJSON(apis.giveawayRulePage, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss"></style>
